// extracted by mini-css-extract-plugin
var _1 = "sTBFlNG2WXe8A0wxpPMv";
export { _1 as "separator" }
